<script>
  export let quoteData = {};
  const { HEADING, TITLE, SUBTITLE, IMAGE_URL, EMAIL, MESSENGER, WHATSAPP } = quoteData;
</script>
<!------------------------------------------->
<!----------------MARKUP----------------------->
<!------------------------------------------->
<section id="quote" class="section">
  <div class="container">
    <h2 class="title text-center">{HEADING}</h2>
    <div class="row section-body">
      <div class="col-md-6">
        <h3 class="about-title">{TITLE}</h3>
        <p>{SUBTITLE}</p>
        <div class="links">
          <a href="mailto:{EMAIL}" target="_blank" class="mail-quote-link">
            <img src="images/mail.svg" alt="email message"/>
          </a>
          <a href="https://m.me/{MESSENGER}" target="_blank" class="quote-messenger-link">
            <img src="images/messenger.svg" alt="messenger message"/>
          </a>
          <a target="_blank" href="https://wa.me/{WHATSAPP}?text="  class="quote-whatsapp-link">
            <img src="images/whatsapp.svg" alt="Whatsapp message"/>
          </a>
        </div>
      </div>
      <div class="col-md-6">
        <img src={IMAGE_URL} alt="" class="img-fluid" />
      </div>
    </div>
  </div>
</section>

<!------------------------------------------->
<!----------------STYLE----------------------->
<!------------------------------------------->
<style>
  .about-title {
    margin-top: 8%;
    margin-bottom: 20px;
  }
  .links a {
    margin-right: 20px;
  }
  .links a img {
    height: 35px;
  }
</style>